import { Card } from "@/shared/components/ui/card"

export function PoliticaCookiesPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8 max-w-8xl">
        <h1 className="text-4xl lg:text-6xl font-bold mb-8">Política de Cookies</h1>

        <Card className="p-8 lg:p-12 space-y-8">
          <p className="text-muted-foreground leading-relaxed">
          
              Última actualización: 2025
            </p>
          <p className="text-muted-foreground leading-relaxed">
              Bienvenido a <strong>Rapyfact</strong>. En este sitio web utilizamos cookies y tecnologías similares para mejorar tu experiencia. Al continuar navegando, aceptas su uso conforme a esta Política de Cookies.
            </p>
          <section className="space-y-4">
            <h2 className="text-2xl font-bold">¿Qué son las Cookies?</h2>
            <p className="text-muted-foreground leading-relaxed">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio
              web. Nos ayudan a mejorar su experiencia y proporcionar funcionalidades esenciales.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold">Tipos de Cookies que Utilizamos</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li>
                <strong>Cookies Esenciales:</strong> Necesarias para el funcionamiento básico del sitio
              </li>
              <li>
                <strong>Cookies de Rendimiento:</strong> Nos ayudan a entender cómo los usuarios interactúan con nuestro
                sitio
              </li>
              <li>
                <strong>Cookies de Funcionalidad:</strong> Permiten recordar sus preferencias
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold">Gestión de Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.
              Para más información sobre cómo gestionar cookies, consulte la ayuda de su navegador.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-2xl font-bold">Cambios en la política de Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nos reservamos el derecho de modificar esta política en cualquier momento. Cualquier cambio será publicado en esta página y notificado cuando sea necesario.
            </p>
          </section>
          <p className="text-muted-foreground leading-relaxed">
  Si tienes dudas sobre nuestra Política de Cookies, puedes contactarnos en{" "}
  <a
    href="mailto:soporte@rapyfact.com"
    className="text-blue-600 hover:underline font-medium"
  >
    soporte@rapyfact.com
  </a>.
</p>

        </Card>
      </div>
    </div>
  )
}
